import { NavLink, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const links = [
  ['/admin', 'admin.nav.risk', 'Fila de risco'],
  ['/admin/metrics', 'admin.nav.metrics', 'Métricas'],
  ['/admin/plans', 'admin.nav.plans', 'Planos e preços'],
  ['/admin/users', 'admin.nav.users', 'Usuários'],
  ['/admin/announcements', 'admin.nav.announcements', 'Comunicados'],
] as const

export function AdminLayout() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-0 flex-1 overflow-hidden">
      <aside
        className="hidden w-56 shrink-0 border-r p-4 md:block"
        style={{ background: 'var(--bg-sidebar)', borderColor: 'var(--border)' }}
      >
        <strong className="mb-4 block text-xs uppercase tracking-wider" style={{ color: 'var(--text-dim)' }}>
          {t('admin.title', 'Administração')}
        </strong>
        <nav className="flex flex-col gap-1">
          {links.map(([to, key, fallback]) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/admin'}
              className="rounded-md px-3 py-2 text-xs font-medium"
              style={({ isActive }) => ({
                background: isActive ? 'var(--bg-card)' : 'transparent',
                color: isActive ? 'var(--accent)' : 'var(--text-muted)',
              })}
            >
              {t(key, fallback)}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <nav className="flex gap-2 overflow-x-auto border-b p-2 md:hidden" style={{ borderColor: 'var(--border)' }}>
          {links.map(([to, key, fallback]) => (
            <NavLink key={to} to={to} end={to === '/admin'} className="whitespace-nowrap rounded px-3 py-2 text-xs">
              {t(key, fallback)}
            </NavLink>
          ))}
        </nav>
        <main className="min-h-0 flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
